import { render, staticRenderFns } from "./modal-send-to-phone.vue?vue&type=template&id=7cdb4e40"
import script from "./modal-send-to-phone.vue?vue&type=script&lang=js"
export * from "./modal-send-to-phone.vue?vue&type=script&lang=js"
import style0 from "./modal-send-to-phone.vue?vue&type=style&index=0&id=7cdb4e40&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports